webpackJsonp([35783957827783],{

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kylegrinstead2021-500.325cd67e.jpg";

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _kylegrinstead = __webpack_require__(107);
	
	var _kylegrinstead2 = _interopRequireDefault(_kylegrinstead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container-fluid' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement('span', { id: 'top', className: 'anchor-tanker' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row top' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4 image-holder' },
	          _react2.default.createElement(
	            'span',
	            { className: 'me image image-full' },
	            _react2.default.createElement('img', { src: _kylegrinstead2.default, alt: '' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8' },
	          _react2.default.createElement(
	            'div',
	            { className: 'hello-box' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Hi. I\u2019m ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Kyle Grinstead'
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#work', className: 'button button-big' },
	              'Find out more about me'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('span', { id: 'work', className: 'anchor-tanker' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper wrapper-style2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'I am a...'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement('span', { className: 'fa featured fa-code' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Developer'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Passionate about writing clean code, constant learning, and helping others. Currently working at ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://bill.com' },
	                  'BILL (on the Divvy product)'
	                ),
	                '.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement('span', { className: 'fa featured fa-building-o' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Entrepreneur'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Always brainstorming new ideas, building cool stuff with technology, and starting new ventures.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement('span', { className: 'fa featured utah-icon' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Utahn'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Excited to be living in a state that has so much to offer, from beautiful hikes to amazing skiing and beyond.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#portfolio', className: 'button button-big' },
	            'See some of my projects'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('span', { id: 'portfolio', className: 'anchor-tanker' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper wrapper-style3' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Projects'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement(
	                'a',
	                { className: 'no-dec', href: 'http://mrgrinst.github.io/rivet-archived-site/' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Rivet'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Although ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'http://mrgrinst.github.io/rivet-archived-site/' },
	                  'Rivet is no more'
	                ),
	                ', I\u2019m very proud of the product I co-founded and built. If you\u2019re interested, you can check out the ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://github.com/MrGrinst/Rivet-iOS' },
	                  'iOS'
	                ),
	                ' or ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://github.com/MrGrinst/Rivet-Android' },
	                  'Android'
	                ),
	                ' source code.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'TBA Project'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Although it\'s not ready enough to be announced, I\'ve started working on a project that will hopefully be fruitful and helpful to others! Details to come.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-4' },
	            _react2.default.createElement(
	              'section',
	              { className: 'box box-style1' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { className: 'no-dec', to: 'blog' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  'Blog'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'A place to share my thoughts with anyone willing to listen. It\u2019s something I should update more often; right now it\u2019s a little bare.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '#contact', className: 'button button-big' },
	            'Get in touch with me'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement('span', { id: 'contact', className: 'anchor-tanker' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper wrapper-style4 contact' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	              'header',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Want to talk? Shoot me an email!'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Email: ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:kyleag@hey.com' },
	                  'kyleag@hey.com'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Or find me on ...'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'social' },
	              _react2.default.createElement(
	                'li',
	                { className: 'twitter' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://twitter.com/mrgrinst', className: 'fa fa-twitter' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Twitter'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'linkedin' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://linkedin.com/in/kylegrinstead/', className: 'fa fa-linkedin' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'LinkedIn'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'github' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://github.com/mrgrinst', className: 'fa fa-github' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Github'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'googleplus' },
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://plus.google.com/+KyleGrinstead?rel=author', className: 'fa fa-google-plus' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'Google Plus'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'rss' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/blog/rss.xml', className: 'fa fa-rss-square' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    'RSS'
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-762c6cc3a4a9c4518501.js